module.exports = __webpack_public_path__ + "static/media/set_attribute.024e88fd.svg";